import { render } from "./PhysiotherapyPrePostPartum.vue?vue&type=template&id=62815bea&scoped=true"
import script from "./PhysiotherapyPrePostPartum.vue?vue&type=script&lang=js"
export * from "./PhysiotherapyPrePostPartum.vue?vue&type=script&lang=js"

import "./PhysiotherapyPrePostPartum.vue?vue&type=style&index=0&id=62815bea&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62815bea"]])

export default __exports__